import React, { Component } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';

export class BatchCheckPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkNumber: '',
      isSubmitting: false
    };
  }

  handleChange = (event) => {
    this.setState({ checkNumber: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    
    const { checkNumber } = this.state;
    const { selectedInvoices, onSubmit } = this.props;
    
    if (!checkNumber.trim()) {
      alert('Please enter a check number');
      return;
    }

    try {
      this.setState({ isSubmitting: true });
      await onSubmit(selectedInvoices, checkNumber);
    } catch (error) {
      console.error("Error processing batch check payment:", error);
      alert('Error processing check payment. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  render() {
    const { show, onClose, selectedInvoices } = this.props;
    const { checkNumber, isSubmitting } = this.state;
    
    const totalAmount = selectedInvoices.reduce((sum, inv) => sum + parseFloat(inv.amount), 0);

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        aria-labelledby="batch-check-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="batch-check-modal">
            Process Check Payment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="batch-check-summary">
            <h5>Selected Invoices ({selectedInvoices.length})</h5>
            <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '20px' }}>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>Invoice #</th>
                    <th>Dealer</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedInvoices.map((invoice) => (
                    <tr key={invoice.invoiceId}>
                      <td>{invoice.invoiceNumber}</td>
                      <td>{invoice.name}</td>
                      <td>{this.formatCurrency(parseFloat(invoice.amount))}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            
            <div style={{ 
              fontSize: '18px', 
              fontWeight: 'bold', 
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px'
            }}>
              Total Amount: {this.formatCurrency(totalAmount)}
            </div>

            <Form onSubmit={this.handleSubmit}>
              <Form.Group controlId="checkNumber">
                <Form.Label>Check Number</Form.Label>
                <Form.Control
                  type="text"
                  name="checkNumber"
                  value={checkNumber}
                  onChange={this.handleChange}
                  placeholder="Enter check number from dealer"
                  required
                  autoFocus
                />
                <Form.Text className="text-muted">
                  This check number will be recorded for all selected invoices
                </Form.Text>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={this.handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Processing..." : "Process Check Payment"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}